// src/router/ocorrenciaFuncionario.js
// Controle de ocorrências do funcionário (RH, TRI-18). A rota /ocorrencias é de outro domínio
// (ocorrências de processo), por isso esta fica sob /rh. O acesso é só da role peopleCulture, sem o
// bypass do admin (`semAdmin`): é dado sensível de RH e a API devolve 403 para as demais roles.

const ocorrenciaFuncionarioBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Ocorrências de funcionários',
    to: 'OcorrenciaFuncionarioList'
  }
]

export default [
  {
    path: '/rh/ocorrencias',
    name: 'OcorrenciaFuncionarioList',
    component: () => import('@/views/PeopleCulture/Ocorrencias/OcorrenciaFuncionarioListPage.vue'),
    meta: {
      roles: ['peopleCulture'],
      semAdmin: true,
      title: 'Ocorrências de funcionários',
      breadcrumb: ocorrenciaFuncionarioBreadCrumb
    }
  }
]
